module.exports = __webpack_public_path__ + "static/media/view.85c0a583.png";